export default __webpack_public_path__ + "static/media/background_new.beb9163a.jpeg";